import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { CandidateMeetingModel, DeclineInterviewRequest, InterviewDashboardResult, InterviewerModel, LocationDescriptor } from "../../../interviews.models";
import { InterviewStatus, InterviewType } from "../../../interviews.enums";
import { RouteReservedPrefix } from "src/app/constants/route-reserved-prefix";
import { InterviewsService } from "../../../services/interviews.service";

@Component({
    selector: 'interview-details-confirmed',
    templateUrl: './interview-details-confirmed.component.html',
    standalone: false
})
export class InterviewDetailsConfirmedComponent {
  @Input() meeting?: CandidateMeetingModel;
  @Input() interviewers: InterviewerModel[] = [];
  @Input() dashboardInfo: InterviewDashboardResult | null = null;

  @Output() onBackButtonClicked: EventEmitter<void> = new EventEmitter();
  @Output() onDeclineInterviewClicked: EventEmitter<DeclineInterviewRequest> = new EventEmitter();
  @Output() onAddToCalendarClicked: EventEmitter<number> = new EventEmitter();

  public InterviewStatus = InterviewStatus;
  public InterviewType = InterviewType;

  public InterviewsRoute = RouteReservedPrefix.INTERVIEWS;

  constructor(private interviewsService: InterviewsService) {}

  public back() {
    this.onBackButtonClicked.emit();
  }

  public getInitials(interviewer: InterviewerModel) {
    return (interviewer.firstName[0] + interviewer.lastName[0]).toUpperCase();
  }

  public isJoinButtonEnabled(meeting: CandidateMeetingModel): boolean {
    return this.interviewsService.isJoinButtonEnabled(meeting);
  }

  public meetingInThePast(meeting: CandidateMeetingModel): boolean {
    return this.interviewsService.meetingInThePast(meeting);
  }  

  public declineInterview(request: DeclineInterviewRequest): void {
    this.onDeclineInterviewClicked.emit(request);
  }

  public addToCalendar(meetingId: number): void {
    this.onAddToCalendarClicked.emit(meetingId);
  }
}
